export default {
  // Navbar
  'nav.home': '首頁',
  'nav.about': '關於我們',
  'nav.solutions': '解決方案',
  'nav.process': '流程',
  'nav.benefits': '優勢',
  'nav.contact': '聯絡我們',
  'nav.getStarted': '開始使用',

  // Hero Section
  'hero.title': '自動化諮詢卓越服務',
  'hero.subtitle': '透過智能自動化轉型您的營運',
  'hero.description': '我們專注於為醫療保健、教育、零售及服務業提供量身定制的IT解決方案，解決實際營運挑戰，實現可衡量的成果。',
  'hero.consultation': '預約諮詢',
  'hero.ourSolutions': '我們的解決方案',

  // About Section
  'about.title': '關於我們',
  'about.subtitle': '您值得信賴的自動化合作夥伴',
  'about.description1': 'Global Pillar Limited於2022年在香港成立。多年來，我們累積了深厚的專業和技術知識，為不同行業提供服務。我們專注於透過結構化的發現、設計、開發和測試流程，提供符合客戶獨特需求的定制IT解決方案。',
  'about.description2': '作為智能手機興起時期移動應用開發的先驅，我們持續整合先進技術，提升服務質量和效率。我們的綜合解決方案使企業能夠在維持可負擔的IT預算的同時無縫運作。',
  'about.stat1': '已完成專案',
  'about.stat2': '服務行業',
  'about.stat3': '客戶滿意度',
  'about.stat4': '全天候支援',

  // Solutions Section
  'solutions.title': '我們的解決方案',
  'solutions.subtitle': '針對您行業的專業自動化諮詢',
  'solutions.healthcare': '醫療保健',
  'solutions.education': '教育',
  'solutions.retail': '零售與服務',
  'solutions.learnMore': '了解更多',
  'solutions.showLess': '收起',
  'solutions.scheduleConsultation': '預約諮詢',

  // Healthcare
  'healthcare.desc': '為醫療機構提供合規、高效的自動化解決方案',
  'healthcare.pain1.title': '分散的患者記錄',
  'healthcare.pain1.challenge': '多個系統導致數據孤島、重複輸入和潛在錯誤',
  'healthcare.pain1.solution': '我們的諮詢方法：實施統一的電子健康記錄(EHR)系統，整合所有患者數據，實現即時訪問和更新',
  'healthcare.pain1.result': '記錄檢索時間減少70%，數據準確性提高40%',
  'healthcare.pain2.title': '手動預約排程',
  'healthcare.pain2.challenge': '電話預約導致雙重預訂、長時間等待和行政負擔',
  'healthcare.pain2.solution': '我們的諮詢方法：部署智能預約系統，具有自動提醒、線上預訂和資源優化功能',
  'healthcare.pain2.result': '未到診率降低60%，行政工作量減少50%',
  'healthcare.pain3.title': '合規報告負擔',
  'healthcare.pain3.challenge': '手動追蹤法規要求耗時且容易出錯',
  'healthcare.pain3.solution': '我們的諮詢方法：自動化合規監控和報告系統，內建審計追蹤和即時警報',
  'healthcare.pain3.result': '合規報告時間減少80%，審計準備改善100%',

  // Education
  'education.desc': '為教育機構提供現代化、互動式的數位解決方案',
  'education.pain1.title': '系統斷裂',
  'education.pain1.challenge': '學生信息、成績和溝通分散在多個平台上',
  'education.pain1.solution': '我們的諮詢方法：整合學習管理系統(LMS)，統一學生數據、成績和家長溝通',
  'education.pain1.result': '行政效率提高65%，家長參與度提升45%',
  'education.pain2.title': '有限的參與追蹤',
  'education.pain2.challenge': '難以監控學生進度和識別需要支持的學生',
  'education.pain2.solution': '我們的諮詢方法：實施分析驅動的追蹤系統，提供即時洞察學生表現和參與度',
  'education.pain2.result': '早期干預改善55%，學生成果提升35%',
  'education.pain3.title': '手動費用收集',
  'education.pain3.challenge': '紙本發票和現金處理導致延遲和對帳問題',
  'education.pain3.solution': '我們的諮詢方法：數位支付系統，具有自動發票、提醒和線上支付選項',
  'education.pain3.result': '準時付款增加75%，行政成本降低40%',

  // Retail & Service
  'retail.desc': '透過智能自動化推動零售和服務業的增長',
  'retail.pain1.title': '庫存差異',
  'retail.pain1.challenge': '手動庫存追蹤導致缺貨、過度庫存和收入損失',
  'retail.pain1.solution': '我們的諮詢方法：即時庫存管理系統，具有自動補貨和預測分析',
  'retail.pain1.result': '缺貨減少60%，庫存成本降低35%',
  'retail.pain2.title': '分散的客戶數據',
  'retail.pain2.challenge': '客戶信息分散在銷售點、線上和忠誠度計劃中',
  'retail.pain2.solution': '我們的諮詢方法：統一的CRM系統，整合所有接觸點，實現個性化營銷和服務',
  'retail.pain2.result': '客戶保留率提高50%，重複購買增加40%',
  'retail.pain3.title': '手動流程',
  'retail.pain3.challenge': '從訂單處理到報告的手動任務消耗寶貴時間',
  'retail.pain3.solution': '我們的諮詢方法：端到端流程自動化，從訂單到履行到財務報告',
  'retail.pain3.result': '處理時間減少70%，營運效率提升55%',

  // Process Section
  'process.title': '我們的諮詢流程',
  'process.subtitle': '以客戶為中心的方法，確保完美契合',
  'process.step1.title': '發現',
  'process.step1.desc': '了解您的業務需求和挑戰',
  'process.step2.title': '設計',
  'process.step2.desc': '打造直觀、可擴展的架構',
  'process.step3.title': '開發',
  'process.step3.desc': '使用最新技術構建可靠和高性能的解決方案',
  'process.step4.title': '測試',
  'process.step4.desc': '嚴格的質量保證，提供無錯誤、高性能的產品',

  // Benefits Section
  'benefits.title': '為什麼選擇我們',
  'benefits.subtitle': '您成功的優勢',
  'benefits.affordable.title': '可負擔的IT預算',
  'benefits.affordable.desc': '我們的解決方案透過優化工作流程和減少手動工作，最大限度地降低長期成本。',
  'benefits.efficiency.title': '提升效率',
  'benefits.efficiency.desc': '整合先進技術以自動化流程並提高服務質量。',
  'benefits.specialized.title': '行業專業顧問',
  'benefits.specialized.desc': '無論是醫療保健的安全數據處理、教育的互動工具，還是零售的智能系統，我們都能根據您行業的需求進行定制。',
  'benefits.expertise.title': '經驗證的專業知識',
  'benefits.expertise.desc': '憑藉多年服務香港充滿活力市場的經驗，我們提供可靠的結果。',
  'benefits.roi.title': '可衡量的投資回報率',
  'benefits.roi.desc': '我們的諮詢方法專注於可量化的成果——效率提升40-80%，成本降低35-70%。',
  'benefits.partnership.title': '端到端合作夥伴關係',
  'benefits.partnership.desc': '從初步諮詢到實施後支持，我們在每一步都與您同在。',

  // Contact Section
  'contact.title': '聯絡我們',
  'contact.subtitle': '準備好轉型您的業務了嗎？',
  'contact.description': '今天就聯絡我們，獲取免費諮詢。讓我們共同構建推動您成功的解決方案！',
  'contact.form.name': '您的姓名',
  'contact.form.email': '您的電子郵件',
  'contact.form.company': '公司名稱',
  'contact.form.industry': '行業',
  'contact.form.industryPlaceholder': '選擇您的行業',
  'contact.form.healthcare': '醫療保健',
  'contact.form.education': '教育',
  'contact.form.retail': '零售與服務',
  'contact.form.other': '其他',
  'contact.form.message': '您的訊息',
  'contact.form.messagePlaceholder': '告訴我們您的需求...',
  'contact.form.submit': '發送訊息',
  'contact.form.sending': '發送中...',
  'contact.form.success': '感謝您！我們會盡快與您聯繫。',
  'contact.form.error': '發送失敗。請稍後再試。',
  'contact.email': '發送電子郵件',
  'contact.directEmail': '或直接發送電子郵件至',

  // Footer
  'footer.tagline': '透過智能自動化轉型您的營運',
  'footer.quickLinks': '快速連結',
  'footer.newsletter': '訂閱電子報',
  'footer.newsletterDesc': '獲取最新的自動化趨勢和行業洞察',
  'footer.emailPlaceholder': '輸入您的電子郵件',
  'footer.subscribe': '訂閱',
  'footer.subscribing': '訂閱中...',
  'footer.subscribeSuccess': '感謝訂閱！',
  'footer.subscribeError': '訂閱失敗。請稍後再試。',
  'footer.rights': '版權所有',
  'footer.poweredBy': '由 Readdy 提供支持',
};